import React from "react";
import Index from "./index";
import ServiceTable from "./ServiceTable";

const Services = () => {
    const { allServices, loading, history, search, setSearch, onDelete } = Index();
    return (
        <ServiceTable
            heading="All Services"
            allServices={allServices}
            loading={loading}
            history={history}
            search={search}
            setSearch={setSearch}
            onDelete={onDelete}
        />
    );
};

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname && prevProps.colorMode === nextProps.colorMode;
};
export default React.memo(Services, comparisonFn);
